import { render, staticRenderFns } from "./CadastroEspecialidades.vue?vue&type=template&id=b1003888&"
import script from "./CadastroEspecialidades.vue?vue&type=script&lang=js&"
export * from "./CadastroEspecialidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports